import Vue from 'vue'
import VueI18n from 'vue-i18n'
import moment from 'moment'
import eventsBus from '@/components/shared/EventsBus'

Vue.use(VueI18n)

const messages = {
  fr: require('@/locales/fr.json'),
  en: require('@/locales/en.json')
}

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: 'en', // set locale
  messages // set locale messages
})

Vue.i18n = i18n

i18n.changeLocale = function (lang, vue) {
  this.locale = lang
  moment.locale(lang)
  vue.$validator.locale = lang
  eventsBus.$emit(eventsBus.LANGUAGE_CHANGED)
}

export default i18n



// WEBPACK FOOTER //
// ./src/utils/i18n.js